import getPublicHeaders from '@/requests/common/getPublicHeaders';

import buildShareRequest from '../buildShareRequest';

import type { PresetShareTarget } from '../shareTarget';

interface ShareLinkResponse {
  status?: string;
  response?: { url?: string };
}

/**
 * Pure request — returns the Adjust short link, or `null` on network failure,
 * an error status, or an unexpected shape. Callers decide how to surface that.
 *
 * Public endpoint: sharing a preset works signed out, so this goes over
 * `getPublicHeaders` (SDK headers minus Authorization) rather than the
 * auth+JSON pair the generation endpoints use.
 */
const createShareLink = async (
  target: PresetShareTarget
): Promise<string | null> => {
  const { endpoint, data } = buildShareRequest(target);
  const headers = new Headers(getPublicHeaders());
  headers.set('Content-Type', 'application/json');

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({ data }),
    });
    if (!response.ok) return null;

    const payload: ShareLinkResponse = await response.json();
    if (payload.status === 'error') return null;

    return payload.response?.url ?? null;
  } catch {
    return null;
  }
};

export default createShareLink;
